export default {
  // ASPICE process names - work products menu
  'menu.process.MAN.3': 'MAN.3 Project Management',
  'menu.process.FSC': 'FSC Functional Safety Concept',
  'menu.process.CSC': 'CSC Cybersecurity Concept',
  'menu.process.SYS.2': 'SYS.2 System Requirements Analysis',
  'menu.process.SYS.3': 'SYS.3 System Architecture Design',
  'menu.process.SWE.1': 'SWE.1 Software Requirements Analysis',
  'menu.process.SWE.2': 'SWE.2 Software Architecture Design',
  'menu.process.SWE.3': 'SWE.3 Software Detailed Design and Unit Construction',
  'menu.process.SWE.4': 'SWE.4 Software Unit Verification',
  'menu.process.SWE.5': 'SWE.5 Software Component Verification and Integration Verification',
  'menu.process.SWE.6': 'SWE.6 Software Verification',
  'menu.process.HWE.1': 'HWE.1 Hardware Requirements Analysis',
  'menu.process.HWE.2': 'HWE.2 Hardware Design',
  'menu.process.HWE.3': 'HWE.3 Hardware Design Verification',
  'menu.process.HWE.4': 'HWE.4 Hardware Requirements Verification',
  'menu.process.SYS.4': 'SYS.4 System Integration and Integration Verification',
  'menu.process.SYS.5': 'SYS.5 System Verification',
  'menu.process.SUP.1': 'SUP.1 Quality Assurance',
  'menu.process.SUP.8': 'SUP.8 Configuration Management',
  'menu.process.SUP.9': 'SUP.9 Problem Resolution',
  'menu.process.ACQ.4': 'ACQ.4 Supplier Management',
  'menu.process.SUP.10': 'SUP.10 Change Management',
  'menu.process.SVV.1': 'SVV.1 Software Verification and Validation',
  'menu.process.SVV.2': 'SVV.2 Software Confirmation',
  'menu.process.SPL.2': 'SPL.2 Product Release',
  'menu.process.TMG.1': 'TMG.1 Tool Management',
};
